/*! Twire util - MIT license  */
import { v4 as uuidv4 } from 'uuid';

export default {
	
	html: function(text) {
		
		return text.replace(/&/g, "&amp;")
	               .replace(/</g, "&lt;")
	               .replace(/>/g, "&gt;")
	               .replace(/"/g, "&quot;")
	               .replace(/'/g, "&#039;");
		
	},
	generateGUID: function() {
		
		return uuidv4();
		
	},
	getUNIXTimestamp: function() {
		
		return Math.floor(Date.now() / 1000);
		
	}
	
};
